import { useContext } from 'react';
import { AuthModalContext } from '../../components/Authentication';

export const useAuthModal = () => useContext(AuthModalContext);
